<template>
  <div class="modal"
       id="modal-create-user"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Register {{ role | capitalize }}
          </h5>
        </div>

        <div class="modal-body">
          <div class="alert alert-success" v-if="createUserForm.successful">
            <i class="fas fa-check-circle"></i> {{ role | capitalize }} registered successfully!
          </div>
          <form role="form">
            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name"
                       type="text"
                       class="form-control"
                       name="name"
                       v-model="createUserForm.name"
                       :class="{'is-invalid': createUserForm.errors.has('name')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createUserForm.errors.has('name')">
                    <strong>{{ createUserForm.errors.get('name') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">Email</label>

              <div class="col-md-6">
                <input id="email"
                       type="email"
                       class="form-control"
                       name="email"
                       v-model="createUserForm.email"
                       :class="{'is-invalid': createUserForm.errors.has('email')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createUserForm.errors.has('email')">
                    <strong>{{ createUserForm.errors.get('email') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

              <div class="col-md-6">
                <input id="password"
                       type="password"
                       class="form-control"
                       name="password"
                       v-model="createUserForm.password"
                       :class="{'is-invalid': createUserForm.errors.has('password')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="createUserForm.errors.has('password')">
                    <strong>{{ createUserForm.errors.get('password') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="password-confirm" class="col-md-4 col-form-label text-md-right">Confirm Password</label>

              <div class="col-md-6">
                <input id="password-confirm"
                       type="password"
                       class="form-control"
                       name="password_confirmation"
                       v-model="createUserForm.password_confirmation"
                       required>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          <button type="submit"
                  class="btn btn-primary"
                  @click.prevent="createUser"
                  :disabled="createUserForm.busy">
            Register
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['role'],

  /**
   * The component's data.
   */
  data () {
    return {
      createUserForm: new AppForm({
        _token: App.csrfToken,
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        role: null,
      })
    };
  },

  methods: {
    /**
     * Create a new User.
     */
    createUser () {
      let self = this;

      this.createUserForm.role = this.role;

      App.post('/api/users', this.createUserForm)
        .then(() => {
          self.createUserForm.name = null;
          self.createUserForm.email = null;
          self.createUserForm.password = null;
          self.createUserForm.password_confirmation = null;
          self.createUserForm.role = null;

          $('#modal-create-user').modal('hide');

          self.$parent.$emit('updateUsers');
        });
    },
  }
};
</script>
